import { Button, Collapse, Dropdown, Menu, Table, Tabs, Modal, Form } from "antd";
const { TabPane } = Tabs;
const { Panel } = Collapse;

import React, { useEffect, useState } from "react";
import {
    AccountDetailsIco,
    AccountExtractIco, AccountMoreIco, ArrowDownIco, ArrowUpIco, BlueEditIcon,
    BusinessCardIco, DovriyyeIcon, ModalCloseIco,
    NewTransferIco, NewTransferIcoNew,
    NoMoneyIco, ReloadIco, TeslifatIcon,
    TransfersIco, TransfersIcoNew, PdfIco, SmsIco, TabsInfoIco
} from "../../../../modules/CustomIcons";
import Icon, { InfoCircleOutlined } from "@ant-design/icons";
import { Link, useHistory, useLocation } from "react-router-dom";
import { connect } from 'react-redux'

import { getAccounts, Account, getRequisitePDFfile } from "../../../services/account";
import { getCurrentCompany } from "../../../services/user";
import { Spinner } from "constants/constants";
import { dateFormatter, financial, removeEmojiCodes } from "../../../services/helper";
import CustomTooltip from "components/Tooltip";
import SearchableColumn from "components/Table/ColumnSearch";
import { updateAccountNickname } from "../../../services/Accounts/AccountNickname";
import { getAccountType } from "../../../services/Transfers/GetCustomerByIban";
import { setMoreDetail, setIbanNumber, getRequisiteData, setAccountLoading } from "../../../store/actions/accountStatement";
import { useActions } from "hooks/useActions";
import './index.scss'
import FullScreenLoading from "components/FullScreenLoading";
import NextModal from "components/NextModalAccount";
import { checkAnyPermission } from "../../../services/permission";
import { useTranslation } from "react-i18next";

const circulationObj = {
    LAST_DAY_BALANCE: 0,
    DEBIT_BALANCE: 0,
    CREDIT_BALANCE: 0,
    BALANCE: 0,
};

const executedObj = {
    BALANCE: 0,
    WFA_AMOUNT: 0,
    WFA_DEBIT: 0,
    WFA_CREDIT: 0,
    WFA_COMMISSION: 0,
    LAST_BALANCE: 0
};

const Accounts: React.FC<any> = ({ companyData, requisiteData, balanceLoading, transferWidgetLoading }) => {
    const {t} = useTranslation();

    const location = useLocation();

    useEffect(() => {
        const layoutScroll = document.getElementsByClassName('layout_scroll')[0];
        layoutScroll.scrollTo({ top: 0 });
    }, [location]);

    const [tableData, setTableData] = useState<Account[]>()
    const [tableLoading, setTableLoading] = useState(Spinner);
    const [filterDateTime, setFilterDateTime] = useState(dateFormatter());
    const [requisiteModalVisible, setRequisiteModalVisible] = useState(false);
    const [executionModalVisible, setExecutionModalVisible] = useState(false);
    const [rowModalVisible, setRowModalVisible] = useState(false);
    const [titleRequisiteState, setTitleRequisiteState] = useState<Array<any>>([]);
    const [ibankRef,setIbankRef]=useState()
    const [open, setOpen] = useState(["1"]);
    const [circulation, setCirculation] = useState(circulationObj);
    const [executed, setExecuted] = useState(executedObj);
    const [rowCurrency, setRowCurrency] = useState('');
    const [form] = Form.useForm();
    const history = useHistory();
    const [data,setData]= useState()
    const { setMoreDetail, setIbanNumber, getRequisiteData, setAccountLoading } = useActions();

    useEffect(()=>{
        let data
        if(requisiteData?.rekvizitAzn){
            data=requisiteData?.rekvizitAzn
            setData(data)
        }else if(requisiteData?.rekvizitUsd){
            data=requisiteData?.rekvizitUsd
            setData(data)
        }else if(requisiteData?.rekvizitEur){
            data=requisiteData?.rekvizitEur
            setData(data)
        }else if(requisiteData?.rekvizitGbp){
            data=requisiteData?.rekvizitGbp
            setData(data)
        }else if(requisiteData?.rekvizitJpy){
            data=requisiteData?.rekvizitJpy
            setData(data)
        }else if(requisiteData?.rekvizitChf){
            data=requisiteData?.rekvizitChf
            setData(data)
        }else if(requisiteData?.rekvizitRub){
            data=requisiteData?.rekvizitRub
            setData(data)
        }else if(requisiteData?.rekvizitCny){
            data=requisiteData?.rekvizitCny
            setData(data)
        }else if(requisiteData?.rekvizitTry){
            data=requisiteData?.rekvizitTry
            setData(data)
        }else if(requisiteData?.rekvizitInr){
            data=requisiteData?.rekvizitInr
            setData(data)
        }
    },[requisiteData])

    const ibanFocus = (e) => {
        e.target.classList.add('editable-form-item');
        e.target.parentElement.parentElement.classList.add('active');
    }

    const ibanBlur = (e) => {
        e.target.classList.remove('editable-form-item');
        e.target.parentElement.parentElement.classList.remove('active');
    }

    const openExecutedModal = (row) => {

        setRowCurrency(old_data => row.CCY_NAME);

        setExecuted(old_data => {
            return {
                BALANCE: row.BALANCE ?? 0,
                WFA_AMOUNT: row.WFA_AMOUNT ?? 0,
                WFA_DEBIT: row.WFA_DEBIT ?? 0,
                WFA_CREDIT: row.WFA_CREDIT ?? 0,
                WFA_COMMISSION: row.WFA_COMMISSION ?? 0,
                LAST_BALANCE: row.LAST_BALANCE ?? 0
            }
        })

        setExecutionModalVisible(true)
    }

    const updateAccountName = (e: any, row: any) => {
        let value = e.target.value.trim();
        let check_value = value.length > 0 ? value : '' /*getAccountType(row.ACCOUNT_TYPE)*/;

        const requestData = {
            IBAN: row.subtitle,
            NICKNAME: check_value
        }

        setTableLoading({
            ...tableLoading,
            spinning: true
        });

        updateAccountNickname(requestData).then(res => {
            fetchData();
        })

    }

    const dropDownVisibleChange = (visible: boolean, record: any) => {

        const newData = tableData;
        newData?.map((item: any) => {
            if (item.key === record.key) {
                item.isDropdown = !item.isDropdown
            } else {
                item.isDropdown = false;
            }
        })
        setTableData(newData)

        if (visible) {
            setCirculation(old_data => {
                return {
                    LAST_DAY_BALANCE: record.rowData.LAST_DAY_BALANCE,
                    DEBIT_BALANCE: record.rowData.DEBIT_BALANCE,
                    CREDIT_BALANCE: record.rowData.CREDIT_BALANCE,
                    BALANCE: record.rowData.BALANCE,
                }
            });
        }

        setIbanNumber({ iban: record["col_1"]["subtitle"], ccy_name: record["col_2"] })

    }

    const sendMoreDetailFunc = (key: string, iban: string, from: string) => {

        setMoreDetail({ key: key, iban: iban, from: from })
    }

    const tableColumns = [
        {
            title: t("home.accountNameNumber"),
            dataIndex: 'col_1',
            key: 'col_1',
            className: 'col_1 ant-table-cell-ellipsis',
            render: (data,alldata) => (
                <>
                    <p className=' align_center not_open_popup' >
                        <div className={'not_open_popup account_edit_nickname account_searchable'} >
                            <Form
                                form={form}
                            >

                                <SearchableColumn
                                    large
                                    title={data.title.split('').length > 27 ? <CustomTooltip title={data.title}>{data.title}</CustomTooltip> : data.title}
                                    customIcon={true} 
                                    form={form}
                                    allowClear={true}
                                    value={data.title}
                                    nickname={alldata.nickname}
                                    name={'updateAccountName'}
                                    /*onChange={(e) => updateAccountName(e, data.subtitle)}*/
                                    onBlur={(e) => updateAccountName(e, data)}
                                />
                            </Form>
                        </div>
                    </p>

                    <CustomTooltip title={data.tooltip} className={'iban_tooltip'} >
                        <span>
                            {data.subtitle}
                            {
                                data.has_cart && <Button icon={<BusinessCardIco />} className='transparent account_card_icon' />
                            }
                        </span>
                    </CustomTooltip>
                </>
            )
        },
        {
            title: t("home.currency"),
            dataIndex: 'col_2',
            key: 'col_2',
            className: 'col_2 ant-table-cell-ellipsis',
            render: data => (
                <>
                    <p className='has_balance'>{data}</p>
                </>
            )
        },
        {
            title: t("home.balance"),
            dataIndex: 'col_3',
            key: 'col_3',
            className: 'col_3 ant-table-cell-ellipsis',
            render: data => (
                <>
                    <p className={parseFloat(data) > 0 ? 'has_balance' : 'no_balance'}>{data}</p>
                </>
            )
        },
        {
            title: t("home.blocked"),
            dataIndex: 'col_4',
            key: 'col_4',
            className: 'columnHasInfoIco col_4 ant-table-cell-ellipsis',
            render: (data: any, record: any) => {
                let p_classname = parseFloat(data.title) > 0 ? 'has_blocked_amount' : 'no_blocked_amount';
                let tooltip_content = (parseFloat(data.title) > 0) ? `<p class="flex direction_column align_center flex_wrap">${t("home.restrictionsOnAccount")}. <Button type='button' class="ant-btn blue-button next_btn btn flex align_center justify_center fit_width acc_block_more_btn" >${t("ads.more")}</Button></p>` : data.title;

                return (
                    <>
                        <p className={`flex align_center justify_end ${p_classname}`}>{data.title}

                            {parseFloat(data.title) > 0 &&
                                <CustomTooltip title={tooltip_content} onClick={() => { history.push({ pathname: '/accounts/accounts' }); sendMoreDetailFunc(record.key, record.col_1.subtitle, "moreButton") }} >
                                    <Button className='has_blocked_data has_blocked_data_1 transparent has_blocked_iconbutton' icon={<InfoCircleOutlined />} />
                                </CustomTooltip>
                            }
                        </p>
                    </>
                )
            }
        },
        {
            title: t("home.availableBalance"),
            dataIndex: 'col_5',
            key: 'col_5',
            className: 'columnFreeBalance col_5 ant-table-cell-ellipsis',
            render: data => {
                let p_classname = ' no_residue_amount ';

                if (parseFloat(data) < 0) {
                    p_classname = ' has_minus_residue_amount'

                } else if (parseFloat(data) > 0) {
                    p_classname = 'has_plus_residue_amount';
                }

                return (
                    <>
                        <p className={` ${p_classname}`}>{data}</p>
                    </>
                )
            }
        },
        {
            title: t("home.executionOnBank"),
            dataIndex: 'col_6',
            key: 'col_6',
            className: 'columnExecutedInBank col_6 ant-table-cell-ellipsis',
            render: data => {
                let tooltip_content = (parseFloat(data.title) !== 0) ? `<p class="flex direction_column align_center flex_wrap">${t("home.transfersOnExecutionOnAccount")} <Button type='button' class="ant-btn blue-button next_btn btn flex align_center justify_center fit_width acc_block_more_btn" >${t("ads.more")}</Button></p>` : data.title;

                return (
                    <>
                        <p className={` ${data?.data?.className}`}>{data.title}
                            {parseFloat(data.title) !== 0 &&
                                <CustomTooltip title={tooltip_content} onClick={(e) => openExecutedModal(data.rowData)} >
                                    <Button className='has_blocked_data transparent' icon={<InfoCircleOutlined />}  style={{ width: 'unset'}}/>
                                </CustomTooltip>
                            }

                            {/* {parseFloat(data.title) !== 0 &&
                                <CustomTooltip title={data.title}>
                                    <Button className='has_blocked_data transparent' onClick={(e) => openExecutedModal(data.rowData)} icon={<InfoCircleOutlined />} />
                                </CustomTooltip>
                            } */}
                        </p>
                    </>
                )
            }
        },
        {
            title: t("home.afterExecution"),
            dataIndex: 'col_7',
            key: 'col_7',
            className: 'column7 col_7 ant-table-cell-ellipsis',
            render: data => {

                let p_classname = '';

                if (parseFloat(data) > 0) {
                    p_classname = ' after_run_amount'

                }

                return (
                    <>
                        <p className={`flex align_center justify_end ${p_classname}`}>
                            {
                                parseFloat(data) < 0 ? <CustomTooltip title={t("home.insufficientFunds")} ><Button icon={<NoMoneyIco />} className='transparent' /></CustomTooltip> : data
                            }
                        </p>
                    </>
                )
            }
        },
        {
            title: '',
            key: 'action',
            fixed: 'right',
            className: 'account_action_col account_col_dropdown col_8 ant-table-cell-ellipsis',
            render: (text, record) => (
                <Dropdown overlay={tableDropDown(record)} trigger={['click']} visible={record.isDropdown} placement="bottomRight" onVisibleChange={(e) => dropDownVisibleChange(e, record)} >
                    <Button icon={<AccountMoreIco />} className='transparent table_more_btn ' />
                </Dropdown>
            ),
        },
    ];

    const updateLoading = () => setAccountLoading(true);

    const fetchData = async () => {

        setTableLoading({
            ...tableLoading,
            spinning: true
        });

        const data = await getAccounts(getCurrentCompany());

        let temp_array = [];

        for (let row of data) {

            if (row.STATUS !== "0") {
                let tooltip_content = `${row.BRANCH_NAME}-da olan ${row.NICKNAME ? row.NICKNAME : getAccountType(row.ACCOUNT_TYPE)}`;
                tooltip_content += `<br/>Yeni IBAN: ${row.IBAN}`;
                tooltip_content += `<br/>Köhnə IBAN: ${row.ORJ_IBAN ?? '-'}`;

                let col_6_class_name = '';

                if (parseFloat(row.WFA_AMOUNT) > 0) {
                    col_6_class_name = 'is_blue';

                } else if (parseFloat(row.WFA_AMOUNT) < 0) {

                    col_6_class_name = 'is_red';
                }
                // @ts-ignore
                temp_array.push({
                    key: row.ACCOUNT_NO,
                    col_1: { title: row.NICKNAME ? row.NICKNAME : getAccountType(row.ACCOUNT_TYPE), subtitle: row.IBAN, tooltip: tooltip_content, has_cart: row.COMPASSACCOUNT, ACCOUNT_TYPE: row.ACCOUNT_TYPE },
                    col_2: row.CCY_NAME,
                    col_3: financial(row.BALANCE),
                    col_4: { title: financial(row.BLOCKSAMOUNT), data: [] },
                    col_5: financial(row.REAL_BALANCE),
                    col_6: { title: financial(row.WFA_AMOUNT), data: { className: col_6_class_name }, rowData: row },
                    col_7: financial(row.LAST_BALANCE),
                    rowData: row,
                    nickname: row.NICKNAME,
                    isDropdown: false
                });
            }

        }

        setTableData(old_data => temp_array);
        setTableLoading({
            ...tableLoading,
            spinning: false
        });

        setFilterDateTime(old_date => dateFormatter())

        setAccountLoading(false)
    };

    useEffect(() => {
        if (!balanceLoading && !transferWidgetLoading) {
            fetchData();
        }
    }, [balanceLoading, transferWidgetLoading]);

    const collapseHeader = (text) => (
        <p>{text}
            <Button
                style={{borderLeft:'none',borderTop:'none',borderBottom:'none',height:'100%',color:'transparent'}}
            >!</Button>
        </p>
    );

    const collapseExtra = () => (
        <>
            <Button icon={<ReloadIco />} onClick={() => {
                fetchData();
                updateLoading();
            }} className='transparent box_reload_ico' />

            <span>{filterDateTime}</span>
        </>
    );

    const rowClassName = (record, index) => {
        return index % 2 ? 'table-row-light' : 'table-row-dark';
    }

    const openCloseCollapse = () => {
        setOpen(prev => prev.indexOf(0) != -1 ? [1] : [0]);
    }

    const openRequisite = (record: any) => {
        const titleRequisite = [
            record.col_1.title,
            record.col_3,
            record.col_2
        ]
        setIbankRef(record.col_1.subtitle)
        setTitleRequisiteState(titleRequisite);
        getRequisiteData({ company: getCurrentCompany(), ibanRef: record.col_1.subtitle })

        setRequisiteModalVisible(old_data => true);
    }

    const tableDropDown = (record: any) => {

        return (<Menu className='hesablar_dropdown accounts_drop_down'>
            <Menu.Item onClick={(e) => { setRowModalVisible(old_data => true); controlDropdownMenu(); return false }} icon={<Icon component={() => (<DovriyyeIcon className={'dovriyye_icon'} />)} />}>
                <div>{t("home.turnover")}</div>
            </Menu.Item>
            {
                checkAnyPermission(['OWN_ACCOUNT', 'INTERNAL', 'EXCHANGE', 'AZIPS', 'XOHKS', 'DXA', 'EDV', 'SWIFT', 'SWIFT_RUB', 'TEMPLATE']) &&
                <Menu.Item icon={<Icon component={() => (<NewTransferIcoNew />)} />}>
                    <Link to={'/new_transfer/'} >{t("home.newTransfer")}</Link>
                </Menu.Item>
            }
            {
                checkAnyPermission(['AZIPS', 'SWIFT', 'XOHKS', 'BATCH_PAYMENT', 'EXCHANGE', 'INTERNAL', 'OWN_ACCOUNT', 'DXA', 'IPS_OTH', 'IPS_BDG', 'IPS_VAT', 'EDV', 'SWIFT_RUB', 'TEMPLATE', 'SALARY_TOTAL']) &&
                <Menu.Item icon={<Icon component={() => (<TransfersIcoNew />)} />}>
                    <Link to={'/transfers/ALL'} >{t("home.transfers")}</Link>
                </Menu.Item>
            }
            <Menu.Item icon={<Icon component={() => (<AccountExtractIco />)} />}>
                <Link to={'/accounts/account_statement'} >{t("home.statement")}</Link>
            </Menu.Item>

            <Menu.Item onClick={() => { sendMoreDetailFunc(record.key, record.col_1.subtitle, "tefsilat") }} icon={<Icon component={() => (<TeslifatIcon />)} />}>
                <Link to={'/accounts/accounts'} >{t("home.details")}</Link>
            </Menu.Item>

            <Menu.Item onClick={(e) => { openRequisite(record); controlDropdownMenu(); return false }} icon={<Icon component={() => (<AccountDetailsIco />)} />}>
                <div>{t("requisites.accountDetails")}</div>
            </Menu.Item>
        </Menu>)
    };

    const controlDropdownMenu = () => {
        const newData = [...tableData];
        if(newData !== undefined) {
            newData?.map((item: any) => {
                item.isDropdown = false
            })
        }
        setTableData(newData)
    };

    useEffect(() => {
        const layoutScroll = document.getElementById("layout_scroll");
        if (typeof layoutScroll !== 'undefined') {
            layoutScroll?.addEventListener('scroll', controlDropdownMenu);

            return () => {
                layoutScroll?.removeEventListener('scroll', controlDropdownMenu);
            };
        }
    });

    const modalDataRequisite = () => {

        return requisiteData?.rekvizitAzn && requisiteData?.rekvizitAzn[0]?.ccyType === "AZN" ? {
            modalTitle: `${t("requisites.accountDetails")}: ${titleRequisiteState[0] ?? ''} ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
            groups: [
                {
                    title: t("requisites.bankAccountDetails"),
                    tableHasBorderBottom: false,
                    data: [
                        {
                            label: t("requisites.customer"),
                            value: requisiteData?.customerName ?? ''
                        },
                        {
                            label: t("requisites.legalAddress"),
                            value: requisiteData?.customerAddress ?? ''
                        },
                        {
                            label: t("requisites.customerBank"),
                            value: requisiteData?.bankName ?? ''
                        },
                        {
                            label: t("requisites.taxID"),
                            value: requisiteData?.bankVoen ?? ''
                        },
                        {
                            label: t("requisites.legalAddress"),
                            value: requisiteData?.bankAddress ?? ''
                        },
                        {
                            label: t("requisites.phone"),
                            value: requisiteData?.bankPhone ?? ''
                        },
                        {
                            label: t("requisites.email"),
                            value: requisiteData?.bankEmail ?? ''
                        },
                    ],
                },
                {
                    title: t("requisites.beneficiary"),
                    tableHasBorderBottom: false,
                    tableHasMarginBottom: true,
                    currency: titleRequisiteState[2] ?? '',
                    data: [
                        {
                            label: t("requisites.name"),
                            value: data ? data[0]?.customerName : '',
                        },
                        {
                            label: t("requisites.taxID"),
                            value: data ? data[0]?.customerVoen : '',
                        },
                        {
                            label: 'IBAN',
                            value: data ? data[0]?.iban : '',
                        }
                    ],
                },
                {
                    title: t("requisites.beneficiaryBank"),
                    tableHasBorderBottom: false,
                    tableHasMarginBottom: true,
                    data: [
                        {
                            label: t("requisites.name"),
                            value: data ? data[0]?.bankName : '',
                        },
                        {
                            label: t("requisites.code"),
                            value: data ? data[0]?.bankCode : '',
                        },
                        {
                            label: t("requisites.mH"),
                            value: data ? data[0]?.bankAccount : '',
                        },
                        {
                            label: 'SWIFT',
                            value: data ? data[0]?.bankSwift : '',
                        },
                    ],
                }
            ],
            buttons: [
                { selectAccount: true }
            ],
        } :
            {
                modalTitle: `${t("requisites.accountDetails")}: ${titleRequisiteState[0] ?? ''} ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
                groups: [
                    {
                        title: t("requisites.bankAccountDetails"),
                        tableHasBorderBottom: false,
                        data: [
                            {
                                label: t("requisites.customer"),
                                value: requisiteData?.customerName ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.customerAddress ?? ''
                            },
                            {
                                label: t("requisites.customerBank"),
                                value: requisiteData?.bankName ?? ''
                            },
                            {
                                label: t("requisites.taxID"),
                                value: requisiteData?.bankVoen ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.bankAddress ?? ''
                            },
                            {
                                label: t("requisites.phone"),
                                value: requisiteData?.bankPhone ?? ''
                            },
                            {
                                label: t("requisites.email"),
                                value: requisiteData?.bankEmail ?? ''
                            },
                        ],
                    },
                    {
                        title: t("requisites.beneficiary"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        currency: titleRequisiteState[2] ?? '',
                        data: [
                            {
                                label: t("requisites.name"),
                                value: data ? data[0]?.customerName : '',
                            },
                            {
                                label: t("requisites.taxID"),
                                value: data ? data[0]?.customerVoen : '',
                            },
                            {
                                label: 'IBAN',
                                value: data ? data[0]?.iban : '',
                            }
                        ],
                    },
                    {
                        title: t("requisites.beneficiaryBank"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: data ? data[0]?.bankName : '',
                            },
                            {
                                label: t("transfers.address"),
                                value: data ? data[0]?.bankAddress : '',
                            },
                            {
                                label: 'SWIFT',
                                value: data ? data[0]?.bankSwift : '',
                            },
                        ],
                    },
                    {
                        title: t("newTransfer.intermediaryBank"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: data ? data[0]?.muhbirName : '',
                            },
                            {
                                label: t("transfers.address"),
                                value: data ? data[0]?.muhbirAddress : '',
                            },
                            {
                                label: 'SWIFT',
                                value: data ? data[0]?.muhbirSwift : '',
                            },
                        ],
                    }
                ],
                buttons: [
                    { selectAccount: true }
                ],
            }
    }

    const handleModalClose = () => {
        setRequisiteModalVisible(false)
    }

    const [exportDetail, setExportDetail] = useState<any>([false, false]);

    const exportRequisitePDF = async (selectedvalue:any) => {
        let newExportDedatil = [...exportDetail];
        newExportDedatil[0] = true;
        setExportDetail(newExportDedatil)

        const formData = {
            ibanRef: ibankRef
        }
        const data = await getRequisitePDFfile(formData,selectedvalue)
        downloadPDF(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);

        newExportDedatil = [...exportDetail];
        newExportDedatil[0] = false;
        setExportDetail(newExportDedatil)
    }

    function downloadPDF(fileName: string, fileBase64: string) {
        const linkSource = `data:application/pdf;base64,${fileBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const sendFunc = () => {
        // console.log("export1")
    }


    const footerBtnsSecondModal = [
        {
            icon: <PdfIco />,
            title: '',
            key: 'pdf',
            loading: exportDetail[0],
            onClickFunc: exportRequisitePDF,
            disabled: false
        },
        {
            icon: <SmsIco />,
            title: '',
            key: 'sms',
            loading: exportDetail[1],
            onClickFunc: sendFunc,
            disabled: true
        },
    ]


    return (
        <>
            <Collapse
                expandIcon={(panelProps) => <Button type={"ghost"} className={'transparent'} onClick={openCloseCollapse} icon={panelProps.isActive ? <ArrowUpIco className={'cursor_pointer'} /> : <ArrowDownIco className={'cursor_pointer'} />} />}
                activeKey={open}
                // onChange={openCloseCollapse}
                expandIconPosition={'end'}
                className='home_page_collapse'
            >


                <Panel
                    header={collapseHeader(t("home.accounts"))}
                    key="1"
                    // onChange={openCloseCollapse}
                    extra={collapseExtra()}
                    collapsible={'header'}
                >


                    <Table
                        pagination={false}
                        // loading={tableLoading}
                        columns={tableColumns}
                        dataSource={tableData}
                        rowClassName={rowClassName}
                        className='table-striped table-hover table table-responsive home_content_table home_account_table'
                        scroll={{ x: true }}
                        onRow={(record, rowIndex) => {
                            return {
                                onClick: e => {

                                    /*let status=
                                        e?.target?.classList?.contains('not_open_popup') ||
                                        e?.target?.classList?.contains('ant-table-column-title') ||
                                        e?.target?.classList?.contains('ant-btn') ||
                                        e?.target?.classList?.contains('anticon') ||
                                        e?.target?.tagName=='button' ||
                                        e?.target?.tagName=='svg' ||
                                        e?.target?.tagName=='path'
                                            ? false : true;

                                    */


                                },
                            };
                        }}
                    />

                </Panel>
            </Collapse>


            <Modal
                title={t("home.executionOnBank")}
                closeIcon={<ModalCloseIco />}
                centered
                visible={executionModalVisible}
                onOk={() => setExecutionModalVisible(false)}
                onCancel={() => setExecutionModalVisible(false)}
                width={460}
                className={'manage_faster_menus requisite_modal form_next_modal'}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={false}
            >

                <ul className='full flex direction_column box_list'>
                    <li className={'no_border'} >
                        <div className={'full flex justify_between'} >
                            <p>{t("home.availableBalance")}</p>
                            <p>{financial(executed.BALANCE)} {rowCurrency}</p>
                        </div>

                        <div className={'full flex justify_center second_title '} >
                            <p>{t("home.paymentOrdersOnExecutionAtBank")}</p>
                        </div>
                    </li>

                    <li>
                        <p>{t("home.credit")}</p>
                        <p className={'is_blue'} >{financial(executed.WFA_CREDIT)} {rowCurrency}</p>
                    </li>

                    <li>
                        <p>{t("home.debit")}</p>
                        <p className={'is_red'} >{financial(executed.WFA_DEBIT)} {rowCurrency}</p>
                    </li>

                    <li>
                        <p>{t("home.commission")}</p>
                        <p className={'is_red'} >{financial(executed.WFA_COMMISSION)} {rowCurrency}</p>
                    </li>

                    <li>
                        <p>{t("home.balanceAfterExecution")}</p>
                        <p>
                            {
                                (financial(executed.LAST_BALANCE) < 0) ? 
                                <CustomTooltip title={t("home.insufficientFunds")} ><Button icon={<NoMoneyIco />} className='transparent' /></CustomTooltip> : `${financial(executed.LAST_BALANCE)} ${rowCurrency}`
                                
                            }
                            {/* // {financial(executed.LAST_BALANCE)} {rowCurrency}Kifayət qədər <br/> vəsait mövcud deyil */}
                        </p>
                    </li>
                </ul>

            </Modal>

            <Modal
                title={t("home.turnoverForCurrentBankingDay")}
                closeIcon={<ModalCloseIco />}
                centered
                visible={rowModalVisible}
                onOk={() => setRowModalVisible(false)}
                onCancel={() => setRowModalVisible(false)}
                width={460}
                className={'manage_faster_menus requisite_modal form_next_modal'}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={false}
            >

                <ul className='full flex direction_column box_list'>

                    <li>
                        <p>{t("home.startingBalance")}</p>
                        <p>{financial(circulation.LAST_DAY_BALANCE)}</p>
                    </li>

                    <li>
                        <p>{t("home.debit")}</p>
                        <p className={'is_red'} >{financial(circulation.DEBIT_BALANCE)}</p>
                    </li>

                    <li>
                        <p>{t("home.credit")}</p>
                        <p className={'is_blue'} >{financial(circulation.CREDIT_BALANCE)}</p>
                    </li>

                    <li>
                        <p>{t("home.balance")}</p>
                        <p>{financial(circulation.BALANCE)}</p>
                    </li>
                </ul>

            </Modal>

            <NextModal
                // btnType={'APPROVE'}
                // requestType={requestType}
                // disabledSign={props.disabledSign}
                // onStatusChange={props.handleStatusChange}
                // nextModalText={'Köçürmələr qrupu banka göndərilir. Nəticəni “Köçürmələr”də izləyə bilərsiniz.'}
                // callBackApi={newTransferFunc}
                visible={requisiteModalVisible}
                data={modalDataRequisite()}
                // // tableTitle ={props.type == 'common' ? '' : t("transfers.transferHistory") }
                // columnsData={columnsData}
                // tableData={props.tableData['SIGN_DETAIL']}
                // type={props.type}
                onClose={handleModalClose}
                // innerColumnsdata={innerColumnsdata}
                // innerrtableData={props.innerrtableData}
                // transferData={props.type == 'common' ? false : true}
                className={'flex_middle rekvizit_modal'}
                source={'requiste'}
                otherButtons={footerBtnsSecondModal}
            />
            {
                tableLoading.spinning ? <FullScreenLoading /> : <></>
            }
        </>
    )
}

const mapDispatchToProps = { setMoreDetail, setIbanNumber, getRequisiteData, setAccountLoading }

const mapStateToProps = (state: any) => ({
    companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result.customerNo : getCurrentCompany(),
    requisiteData: state.accountsStatement.requisiteData.result ?? [],
    balanceLoading: state.accountsStatement.balanceLoading,
    transferWidgetLoading: state.accountsStatement.transferWidgetLoading,
})

export default connect(mapStateToProps, mapDispatchToProps)(Accounts)

